import { get } from 'lodash';
import { getLogoType } from '../get-logo';
export function getTopSpacerSection({ composerData, css, }) {
    const hasTopSpacer = getLogoType(composerData) !== 'strip';
    const bodyTopPadding = parseInt(get(css, 'so-global-body.paddingTop'), 10) || 0;
    if (hasTopSpacer) {
        return {
            height: bodyTopPadding,
            cssClass: '',
        };
    }
    return null;
}
//# sourceMappingURL=get-top-spacer-section.js.map